import { render, staticRenderFns } from "./MPreviewFrame.vue?vue&type=template&id=26348286&"
import script from "./MPreviewFrame.ts?vue&type=script&lang=ts&"
export * from "./MPreviewFrame.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports